var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.check)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"primary","dark":"","rounded":""},on:{"click":function($event){return _vm.generateMenage()}}},'v-btn',attrs,false),on),[_vm._v(" Générer ménage ")])]}}],null,false,2492926655)},[_c('span',[_vm._v("Générer ménage")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }